import React from 'react';

const Error = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>❌ Payment Failed</h1>
      <p>There was an issue with your payment. Please try again.</p>
    </div>
  );
};

export default Error;
